import { create } from "zustand"

// Maps condition confidence to overlay opacity
export const confidenceToOpacity = (confidence) => {
  switch (confidence) {
    case "high": return 0.55
    case "medium": return 0.35
    case "low": return 0.18
    default: return 0.25
  }
}

// Amber/orange colour for highlighted areas
export const HIGHLIGHT_COLOR = "#F97316"

export const useHighlightedAreasStore = create((set) => ({
  // { areaName: { confidence, conditionName, opacity } }
  highlightedAreas: {},

  setHighlightedAreas: (areas) => set({ highlightedAreas: areas }),

  clearHighlightedAreas: () => set({ highlightedAreas: {} }),
}))
